export default class Structor {
  /**
   *
   * @param {object} attributes
   * @param {*} map
   * @param {*} key
   * @param {*} val
   */
  _field(attributes, map, key, val) {
    if (typeof val === "function") {
      attributes[key] = val(map)
    } else {
      attributes[key] = map[key] === undefined ? val : map[key]
    }
  }
  constructor(map = {}) {
    let attributes = {}
    // this.field = (key, val) => this._field(attributes, map, key, val)
    this.field = function (key, val) {
      this._field(attributes, map, key, val)
    }
    this.defineStruct()
    return attributes
  }
}
